import { buildComponent } from '#components'
import { z } from 'zod'
import EditorialCardVue from './EditorialCard.vue'
import type { EditorialCardProps } from './types'

import './editorial-card.css'

const EditorialCardPropsSchema = z.object({
  imageDesktop: z.string(),
  imageMobile: z.string().nullable().optional(),
  title: z.string().nullable().optional(),
  content: z.string().nullable().optional(),
  shopTheLookTitle: z.string().nullable().optional(),
  link: z.string().nullable().optional(),
  externalLink: z.boolean().optional(),
  shopTheLookHandles: z.array(z.string().nullable()).optional()
})

const EditorialCard = buildComponent({
  name: 'editorial-card',
  propsSchema: EditorialCardPropsSchema,
  vueComponent: EditorialCardVue
})

declare global {
  interface HTMLElementTagNameMap {
    'editorial-card': HTMLElement
  }
}

export type { EditorialCardProps }
export default EditorialCard
